import React, { useLayoutEffect } from 'react';
import { TabPermissionItem } from '../modules/BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';
import { ModuleKey } from '../modules/Module';
import { getPermissionTabsFactory } from '../services/permissions/PermissionsTabs';

type PermissionsItemType = Partial<Record<ModuleKey, TabPermissionItem[]>>;
export type PermissionsContextType = {
    items: PermissionsItemType;
    allItems: TabPermissionItem[];
    register: (moduleKey: ModuleKey, items: TabPermissionItem[]) => void;
    unregister: (moduleKey: ModuleKey) => void;
};

export const PermissionsContext = React.createContext<PermissionsContextType>({
    items: {},
    allItems: [],
    register: () => {},
    unregister: () => {},
});

//TODO, PGU: Voir pour refacto cette partie "getPermissionTabsFactory"
let allPermissions: TabPermissionItem[] = [];

export const PermissionsContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
    useLayoutEffect(() => {
        //Register only if PermissionsContextProvider is loaded asap.
        getPermissionTabsFactory.register('**', () => allPermissions);
    }, []);
    const [items, setItems] = React.useState<PermissionsItemType>({});
    const register = (moduleId: string, routes: TabPermissionItem[]) => {
        setItems((r) => ({ ...r, [moduleId]: routes }));
    };
    const unregister = (moduleId: ModuleKey) => {
        setItems((r) => {
            const { [moduleId]: _, ...rest } = r;
            return rest;
        });
    };

    const allItems = Object.keys(items)
        .map((key) => items[key])
        .flat() as TabPermissionItem[];
    allPermissions = allItems;

    return (
        <PermissionsContext.Provider value={{ items, allItems, register, unregister }}>
            {children}
        </PermissionsContext.Provider>
    );
};
